import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61a06ba5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body p-10" }
const _hoisted_2 = { class: "row align-items-center desktop" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "formacion row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "textoformacion" }, "FORMACIÓN")
], -1))
const _hoisted_6 = { class: "col-11 pl-2 padimagen" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "espacio" }, null, -1))
const _hoisted_9 = { class: "mt-5 fs-1" }
const _hoisted_10 = { class: "mt-2 fs-4 intro-dinamica" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-file-pdf fa-xl colorAzul me-2" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-file-pdf fa-xl colorAzul me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: 
                _ctx.headerImage || 'media/illustrations/portada_placeholder.jpeg'
              ,
              alt: "Portada IAM Formación",
              class: "img-fluid img-portada card"
            }, null, 8, _hoisted_7)
          ])
        ])
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("cursosFormacionMujeres")), 1),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", { innerHTML: _ctx.introHtml }, null, 8, _hoisted_11),
        (_ctx.pdfResumen || _ctx.pdfPrograma)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
              (_ctx.pdfResumen)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openPdf(_ctx.pdfResumen, _ctx.pdfResumenName)), ["prevent"])),
                    class: "me-10"
                  }, [
                    _hoisted_13,
                    _createTextVNode(" " + _toDisplayString(_ctx.pdfResumenName), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.pdfPrograma)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openPdf(_ctx.pdfPrograma, _ctx.pdfProgramaName)), ["prevent"]))
                  }, [
                    _hoisted_14,
                    _createTextVNode(" " + _toDisplayString(_ctx.pdfProgramaName), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}